<template>
	<div class="ui basic padded segment">
		<div class="ui divider horizontal header"><i class="user icon"/>{{ $t('pages.profile.settings.profile.header') }}</div>
		<profile-settings ref="ProfileSettings"></profile-settings>

    <div class="ui divider horizontal header">
      <i class="file icon"/>
      {{ $t('pages.profile.settings.documentation.header') }}
    </div>

    <documentation-settings ref="DocumentationSettings"></documentation-settings>

		<div class="ui divider horizontal header">
			<i class="large icons">
				<i class="shield alternate icon"/>
				<i class="bottom right corner setting icon"/>
			</i>
			{{ $t('pages.profile.settings.privacy.header') }}
		</div>

		<privacy-settings ref="PrivacySettings"></privacy-settings>
	</div>
</template>

<script>
	export default {
    name: 'edit',
    layout: 'app',

		data () {
			return {}
		},

		beforeRouteLeave (to, from, next) {
			// Make sure Profile Settings are saved before leaving the route.
			this.$refs.ProfileSettings.submitForm()
				.then(() => {
            if (this.$store.getters.activeMerchant && this.$store.getters.activeMerchant.opus) {
              this.$refs.ProfileSettings.saveUserSocialNumber()
                .then(() => {
                  next()
                }).catch(() => {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: 'Please check all the required fields in Profile',
                  type: 'error',
                  align: 'right'
                })
              })
            } else {
              next()
            }
				}).catch(() => {
        this.$events.$emit('alert', {
          header: this.$t('globals.validation.errors.error'),
          message: 'Please check all the required fields in Profile',
          type: 'error',
          align: 'right'
        })
      })
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/profile/ProfileSettings.vue